// import '../../Assets/Styles/register.css';
import './ModalSearch.css';
import React,{useState,useEffect} from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Skeleton } from 'primereact/skeleton';
import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';

import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputSwitch } from 'primereact/inputswitch';
import { Tooltip } from 'primereact/tooltip';

import Grid from '@mui/material/Grid';

import { useMediaQuery } from 'react-responsive';

import {APIProvider, Map,Marker, InfoWindow} from '@vis.gl/react-google-maps';

import TagManager from 'react-gtm-module';

// Load Actions
import * as AppActions from '../../Store/Actions/App';

import AlertView from '../../Components/AlertModal';

import clinicPhotoPlaceholder from '../../Assets/Images/clinicPhotoPlaceholder.png';
import iconContactWpp from '../../Assets/Images/iconContactWpp.svg';
import iconContactPhone from '../../Assets/Images/iconContactPhone.svg';
import iconContactEmail from '../../Assets/Images/iconContactEmail.png'; // Import
import iconHomeAddress from '../../Assets/Images/iconHomeAddress.svg';

import {
	padronizarDecimal,
    disableBodyScroll,
    enableBodyScroll,
    maskCPF,
    maskPhone,
    validarCPF,
    validarEmail,
    validarTelefone,
    resumeCompanyName
} from '../../Components/Utils';


const apiKey = 'AIzaSyBFNooJFvoHEGeQOJqUuekFHT1PRQ8TbCs';


// UpdateService dialog component
const MapSearchClinicView = (props) => {

// set vars from props
const { 
    dialog,
    setDialog,
	searchType = 'clinic',
	address,
    coordinates,
	scrollBlock,
    selectedService,
    selectedDiscount
} = props;


const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

const [loading, setLoading] = React.useState(true); 
const [loadingCompany, setLoadingCompany] = React.useState(false); 

const [selectingCompany, setSelectingCompany] = React.useState({}); 
const [center, setCenter] = React.useState(null);
const [markerCenter, setMarkerCenter] = React.useState(null);
const [zoom, setZoom] = React.useState(12);

// Interaction Control
const [searching, setSearching] = React.useState(false);
const [formValidated, setFormValidated] = React.useState(false);

// Form control
const [personDocument, setPersonDocument] = React.useState("");
const [personEmail, setPersonEmail] = React.useState("");
const [personPhone, setPersonPhone] = React.useState("");
const [notForMe, setNotForMe] = React.useState(false); // if true, its not for me.
const [acceptTerms, setAcceptTerms] = useState(false);

const [personName, setPersonName] = React.useState(null);


// Terms control
  const [showPrivacyDialog, setShowPrivacyDialog] = useState(false);
  const [showUsageDialog, setShowUsageDialog] = useState(false);
  const [privacyContent, setPrivacyContent] = useState('');
  const [usageContent, setUsageContent] = useState('');

  const [loadingPrivacy, setLoadingPrivacy] = useState(false);
  const [loadingUsage, setLoadingUsage] = useState(false);
  
  const [showSearchedClinics, setShowSearchedClinics] = useState(false);
  const [showScheduledClinic, setShowScheduledClinic] = useState(false);
  const [showNotFoundClinic, setShowNotFoundClinic] = useState(false);


  const [selectedCompany, setSelectedCompany] = useState({});
  const [hoveredClinic, setHoveredClinic] = useState(null);

  const [foundCompanies, setFoundCompanies] = useState([]);
  const [foundMapCompanies, setFoundMapCompanies] = useState([]);


// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 
const [alertAction, setAlertAction] = React.useState(null);  
  
  
  console.log('selectedCompany |-----------------> '+JSON.stringify(selectedCompany,null,2));
  //console.log('hoveredClinic |-----------------> '+JSON.stringify(hoveredClinic,null,2));
  //console.log('foundMapCompanies |-----------------> '+JSON.stringify(foundMapCompanies,null,2));

  const itemRefs = React.useRef([]);  

/* Process informations, generate lead and start chat */
const handleStartChat = () => {

    console.log("START CHAT");

    if (!selectedCompany?.company?.id) {
        console.warn('Nenhuma empresa selecionada.');
        setAlertTitle("Erro");
        setAlertBody("Nenhuma empresa foi selecionada para gerar o atendimento. Tente novamente.");
        setAlert(true);
        return;
    }

    // Nova validação agrupada
    const validationErrors = [];

    if (!personDocument || !validarCPF(personDocument)) {
        validationErrors.push("• CPF inválido");
    }

    if (!personEmail || !validarEmail(personEmail)) {
        validationErrors.push("• Email inválido");
    }

    if (!personPhone || !validarTelefone(personPhone)) {
        validationErrors.push("• Telefone inválido");
    }

    if (!acceptTerms) {
        validationErrors.push("• É necessário aceitar a Política de Privacidade e os Termos de Uso");
    }

    if (validationErrors.length > 0) {
        setAlertTitle("Verifique os campos abaixo:");
        setAlertBody(
            <div>
                {validationErrors.map((err, index) => (
                    <div key={index}>{err}</div>
                ))}
            </div>
        );
        setAlert(true);
        return;
    }

    if (!formValidated) {
        showFormWarning();
        return;
    }

    setLoadingCompany(true);

    // Montar customerAddress corretamente:
    const terms = address?.terms || [];
    const hasNumber = terms.length === 6;

    const customerAddress = {
        fullAddress: address?.description || '',
        googleCoordinates: address?.coordinates ? JSON.stringify(address?.coordinates) : '',
        latitude: coordinates?.lat || null,
        longitude: coordinates?.lng || null,
        streetName: terms[0]?.value || 'XX',
        streetNumber: hasNumber ? (terms[1]?.value || 'Sem número') : 'Sem número',
        suburb: hasNumber ? (terms[2]?.value || 'Sem bairro') : (terms[1]?.value || 'Sem bairro'),
        city: hasNumber ? (terms[3]?.value || 'Sem cidade') : (terms[2]?.value || 'Sem cidade'),
        state: hasNumber ? (terms[4]?.value || 'XX') : (terms[3]?.value || 'XX')
    };

    // Montar payload conforme o backend espera:
    const payload = {
        customerDocument: personDocument?.replace(/\D/g, ''),
        customerEmail: personEmail?.trim(),
        customerPhone: personPhone?.replace(/\D/g, ''),
        otherPerson: notForMe ? 1 : 0,
        customerAddress: customerAddress,
        companyType: searchType,
        companyServiceId: searchType === 'clinic' ? selectedService : null,
        companyDiscountCouponId: searchType === 'optics' ? selectedDiscount : null,
        companyId: selectedCompany.company.id,
        selectedService: selectedCompany?.config || null,  // objeto completo
        selectedDiscount: selectedCompany?.config || null // objeto completo
    };

    props.createCustomerLead(payload, {
        setSuccess: (response) => {
            
            //console.log('Resposta da criação do lead:', response);

            // Se retornou conflito de email/telefone
            if (response.alreadyExists) {
                let conflictMsg = "Email e/ou telefone já estão vinculados a outro cliente:";

                if (response.conflictFields.email && response.conflictFields.phone) {
                    conflictMsg = "O email e o telefone informados já estão vinculados a outro CPF. Por favor, utilize outro email e/ou telefone.";
                } else if (response.conflictFields.email) {
                    conflictMsg = "O email informado já está vinculado a outro CPF. Por favor, utilize outro email.";
                } else if (response.conflictFields.phone) {
                    conflictMsg = "O telefone informado já está vinculado a outro CPF. Por favor, utilize outro telefone.";
                }

                setLoadingCompany(false);
                setAlertTitle("Dados já utilizados");
                setAlertBody(conflictMsg);
                setAlert(true);
                return; // não segue o fluxo normal
            }

            // Caso contrário, fluxo normal (lead criado)
           // console.log('Lead gerado com sucesso:', response);

            setLoadingCompany(false);
            setShowScheduledClinic(true);

            setPersonName(response?.CustomerFirstName || ''); // Atualiza o nome do cliente
            
            const cleanNumber = selectedCompany.company.phone?.replace(/\D/g, '');
            const message = searchType == "clinic" ? 'Olá, quero agendar minha consulta!' : 'Olá, quero obter o meu desconto!';

            // encodeURIComponent é importante para garantir que a mensagem fique bem formatada na URL
            const encodedMessage = encodeURIComponent(message);            
            if (cleanNumber) {
                const whatsappUrl = `https://wa.me/${cleanNumber}?text=${encodedMessage}`;
                const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

                if (isIOS) {
                    // window.location.href = whatsappUrl;
                } else {
                    window.open(whatsappUrl, '_blank');
                }
            } else {
                console.warn('Telefone da empresa não encontrado. Não foi possível abrir o WhatsApp.');
            }
        },        
        setError: (message) => {
            console.error('Erro ao gerar lead:', message);
            setLoadingCompany(false);
            setAlertTitle("Erro ao gerar lead");
            setAlertBody(message);
            setAlert(true);
        }
    });
};

const openWhatsAppChat = (phoneNumber) => {
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isDesktop = !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    
    const message = searchType == "clinic" ? 'Olá, quero agendar minha consulta!' : 'Olá, quero obter o meu desconto!';

    // encodeURIComponent é importante para garantir que a mensagem fique bem formatada na URL
    const encodedMessage = encodeURIComponent(message);           
 

    if (isDesktop) {
        // Desktop → WhatsApp Web
        const whatsappWebUrl = `https://wa.me/${cleanNumber}?text=${encodedMessage}`;
        window.open(whatsappWebUrl, '_blank');
    } else {
        // Mobile (iOS ou Android) → whatsapp:// scheme
        const whatsappUrl = `whatsapp://send?phone=${cleanNumber}&text=${encodedMessage}`;

        // iOS precisa de um click direto para abrir o WhatsApp
        // ⚠️ No iOS precisa ser click direto (usar no evento de click)
        window.location.href = whatsappUrl;
    }
};


const handleStartContact = (phoneNumber, phoneType) => {
    if (!phoneNumber) {
        console.warn('Número de telefone não informado');
        return;
    }

    // Limpar caracteres não numéricos
    const cleanNumber = phoneNumber.replace(/\D/g, '');

    if (phoneType === 'wpp') {
        // Usar função genérica que já cuida de Desktop, Android e iOS
        openWhatsAppChat(cleanNumber);
    } else {
        // Montar link tel:
        const telUrl = `tel:${cleanNumber}`;
        window.location.href = telUrl;
    }
};


/* Search more options */
const handleStartSearch = () => {

    console.log("START SEARCH");

    setSearching(true);

    setTimeout(function() {
        setSearching(false);
        setShowSearchedClinics(true);
    },2000);

}

// Close searched clinics
const closeSearchedClinics = () => {
    console.log("CLOSE SEARCHED CLINICS");
    setShowSearchedClinics(false);
}

// Select Company
const selectCompany = (companyId) => {

    console.log("SELECT COMPANY");
    const loadingCompany = {};
    loadingCompany[companyId] = true;    
    setSelectingCompany(loadingCompany);

    const selected = foundCompanies.find(c => c.company.id === companyId);
    setSelectedCompany(selected);

    setTimeout(function() {

        loadingCompany[companyId] = false;    
        setSelectingCompany(loadingCompany);        

        setShowSearchedClinics(false);
    },1000);

}

// Show form warning
const showFormWarning = () => {
    setAlertTitle("Atenção");
    setAlertBody("Preencha todos os campos do formulário, incluindo o aceite aos termos, para iniciar a conversa.");
    setAlertAction(null);
    setAlert(true);
    setTimeout(() => {
        setAlert(false);
    }, 5000);
}


//console.log('markerCenter |---------------------> '+JSON.stringify(markerCenter,null,2));
//console.log('center  |---------------------> '+JSON.stringify(center,null,2));


// Estilos do mapa para remover apenas hotéis
// https://developers.google.com/maps/documentation/javascript/style-reference?hl=pt-br

const mapOptions = {
    styles: [
        {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.business",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.medical",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.place_of_worship",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }
    ],
};

const footerContent = (
	<div className="modalFooterButtonsEnd">

		<div>
            {!loading &&
			    <Button label="Fechar" icon="pi pi-times" className="p-button-tex footerButton" onClick={() => close()} />
            }
		</div>
		
	</div>
);	


// Execute when dialog opens
React.useEffect(() => {

	// Only r]uns when  dialog opens
	if (dialog.target == 'MapSearchClinicViewModal' && dialog.status) {

        // set Loading on
        setLoading(true);

        // turn off parent scroll
        disableBodyScroll();

       // setCenter(coordinates);
       // setMarkerCenter(coordinates);

        // Load clinics FAKE
       // setFoundCompanies(fakeClinics);
       // setFoundMapCompanies(fakeClinics);

        // Suponha que o JSON esteja na variável `data`
        const terms = address?.terms || [];
        const hasNumber = terms.length === 6;
       
       const cidade = hasNumber ? (terms?.[3]?.value || null) : (terms?.[2]?.value || null);
       const estado = hasNumber ? (terms?.[4]?.value || null) : (terms?.[3]?.value || null);

        props.retrieveNearCompaniesAlternative({
            type: searchType,
            addressCoordinates: {
                latitude: coordinates?.lat,
                longitude: coordinates?.lng
            },
            addressState: estado || '',  // ajuste conforme sua estrutura do address
            addressCity: cidade || '',    // ajuste conforme sua estrutura do address
            serviceId: searchType === 'clinic' ? selectedService : null,
            discountId: searchType === 'optics' ? selectedDiscount : null
        }, {
            setSuccess: (data) => {
                setFoundCompanies(data.companies || []);
                setFoundMapCompanies(data.companies || []);

                if (data.selectedCompany) {
                    setSelectedCompany(data.selectedCompany);
                    setMarkerCenter({
                        lat: parseFloat(data.selectedCompany.address.latitude),
                        lng: parseFloat(data.selectedCompany.address.longitude)
                    });
                    setCenter({
                        lat: parseFloat(data.selectedCompany.address.latitude),
                        lng: parseFloat(data.selectedCompany.address.longitude)
                    });
                    setShowNotFoundClinic(false);
                } else {
                    setShowNotFoundClinic(true);
                }

                setSearching(false);
                setLoading(false);
            },
            setError: (message) => {
                console.error('Erro ao buscar empresas:', message);
                setShowNotFoundClinic(true);
                setFoundCompanies([]);
                setFoundMapCompanies([]);
                setSearching(false);
                setLoading(false);
            }
        });       

        // Forcing
        //setShowNotFoundClinic(true);


        setTimeout(function() {
            setLoading(false);
        },3000);

	} // end if
    else {
        setLoading(true);
        setCenter(null);
        setMarkerCenter(null);
    }
	
	// Reset all fields when closes or open dialog
	// ...
			
},[dialog]);

// Execute when dialog opens
React.useEffect(() => {
	
    //setShowNotFoundClinic(true);

	// Reset all fields when closes or open dialog
  // Runs when UNMOUNT component
  return () => {
    setLoading(true);
    setCenter(null);
    setMarkerCenter(null);  
    enableBodyScroll()  
  };
			
},[]); 


// Validated Form after any change
React.useEffect(() => {

    const validDocument = personDocument && validarCPF(personDocument);
    const validEmail = personEmail && validarEmail(personEmail);
    const validPhone = personPhone && validarTelefone(personPhone);
    const validTerms = acceptTerms;

    const isValid = validDocument && validEmail && validPhone && validTerms;
    setFormValidated(isValid);

}, [personDocument, personEmail, personPhone, acceptTerms]);


const close = ()=> {

	setDialog("MapSearchClinicViewModal",false);

    // Reset all fields when closes or open dialog
    setShowScheduledClinic(false);
    setShowNotFoundClinic(false);
    setShowPrivacyDialog(false);
    setShowUsageDialog(false);
    setShowSearchedClinics(false);
    setHoveredClinic(null);

    setFormValidated(false);
    setPersonDocument(null);
    setPersonEmail(null);
    setPersonPhone(null);
    setNotForMe(false); 
    setAcceptTerms(false);

    setLoading(true);
    setSearching(false);
    setCenter(null);
    setMarkerCenter(null);    
    enableBodyScroll()

}

  const openPrivacyDialog = async () => {
    setShowPrivacyDialog(true);      // Abre o modal imediatamente
    setLoadingPrivacy(true);         // Ativa o loading
    disableBodyScroll(); // 🛑 bloqueia scroll da página
    try {
      const res = await fetch('https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/pages/3');
      const json = await res.json();
      setPrivacyContent(json.content.rendered);
    } catch (error) {
      console.error('Erro ao buscar Política de Privacidade:', error);
      setPrivacyContent('<p>Erro ao carregar conteúdo. Tente novamente mais tarde.</p>');
    } finally {
      setLoadingPrivacy(false);      // Finaliza o loading
    }
  };
  
  const openUsageDialog = async () => {
    setShowUsageDialog(true);
    setLoadingUsage(true);
    disableBodyScroll(); // 🛑 bloqueia scroll da página
    try {
      const res = await fetch('https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/pages/550');
      const json = await res.json();
      setUsageContent(json.content.rendered);
    } catch (error) {
      console.error('Erro ao buscar Termos de Uso:', error);
      setUsageContent('<p>Erro ao carregar conteúdo. Tente novamente mais tarde.</p>');
    } finally {
      setLoadingUsage(false);
    }
  };

const handleEventAppClick = (eventName) => {
  TagManager.dataLayer({
    dataLayer: {
      event: eventName,
      category: 'Evento Conversao'
    }
  });
};  

	return (
	<>
			<Dialog className="searchDialog" closable={true}  dismissableMask={!showScheduledClinic ? true : false} visible={dialog.target == 'MapSearchClinicViewModal' && dialog.status} style={{ width: '75vw',height:'100vh' }} breakpoints={{ '1500px': '95vw','960px': '80vw', '641px': '100vw' }} onHide={() => close()} closeOnEscape={!showScheduledClinic ? () => close() : false}  >
			
				<div className="flex-row justify-center align-items-center w100" style={{padding:"0.5rem",height:"100%",gap:"1rem",justifyContent:showScheduledClinic ? "flex-end" : (isMobile ? "flex-end" : ""),flexDirection:isMobile ? "column-reverse" : ""}}>
                        
                    {loading &&
			                <div style={{backgroundColor:"transparent",display:"flex",justifyContent:"center",alignItems:"center",width:"100%",height:"80vh",padding:"30px"}}>

                                <div style={{flex:1,display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",width:"20vw",textAlign:"center",marginTop:"-5rem"}}>
                                    <ProgressSpinner />
                                    <div className="formTitle" style={{marginBottom:"15px",marginTop:"25px",fontSize:"2rem"}}>Buscando uma {searchType == 'clinic' ? 'Clínica' : 'Ótica'} <br /> perto do seu endereço...Aguarde! </div>
                                </div>

                            </div>           
                    }

                    {(!loading) &&
                    <>
                    <div className="flex-column justify-center align-items-start" style={{alignSelf:"stretch",flex:showScheduledClinic ? "1" : (isMobile ? "0.9" : "0.7"),marginTop:isMobile ? "0rem" : ""}}>
                        
                        <div className="searchClinicForm flex-column justify-center align-items-start w100">

                            <div className="formContent w100 flex-column justify-center align-items-center"> 

                                {/* [OVER SCREEN] Not found Clinic or optics */}
                                <div className={showNotFoundClinic ? "flex-column justify-center align-items-center notFoundClinic show" : "flex-column justify-center align-items-center notFoundClinic hide"}>

                                    <div className="formContent w100 flex-column justify-center align-items-center flex-1">        


                                        {/* Nothing found near to you */}
                                        <div className="flex-column justify-center align-items-start tAlignL">

                                            <p className="notFoundTitle">Poxa...que pena! :-(</p>
                                            <p className="notFoundSubtitle">Não encontramos uma {searchType == "clinic" ? "clínica" : "ótica"} perto do endereço fornecido.</p>
                                            <p className="notFoundText">
                                                Algumas opções que você pode tentar:

                                                <ul>
                                                    <li>Digite outro endereço</li>
                                                    <li>Verifique se o endereço digitado está correto</li>
                                                    <li>Altere o {searchType == "clinic" ? "serviço" : "desconto"} selecionado</li>
                                                    <li>Entre em contato com o suporte</li>
                                                </ul>
                                                
                                            </p>
                                            <p className="notFoundext">Você pode retornar em outro momento pois estamos constantamene adicionando novos parceiros.</p>

                                        </div>   

                                    </div>
                                    

                                </div>

                                {/* [OVER SCREEN] Searched Clinics/ Optics List Panel */}
                                <div className={showSearchedClinics ? "flex-column justify-center align-items-center searchedClinics show" : "flex-column justify-center align-items-center searchedClinics hide"}>

                                    <div className="backButtonWrapper w100"><Button icon="pi pi-chevron-left" className="backButton" text label="Retornar a clínica selecionada" onClick={()=>closeSearchedClinics()} /></div>

                                    <div className="searchedClinicsTitle w100">Outras opções de {searchType == 'clinic' ? "Clínicas" : "Óticas"}</div>
                                    <div className="searchedClinicsList flex-column justify-start align-items-center w100">
                                                                                
                                            {foundCompanies.map((clinic, index) => (
                                                <div
                                                    key={index}
                                                    ref={(el) => (itemRefs.current[index] = el)}
                                                    className={`searchedClinicItem w100 flex-row justify-start align-items-center ${hoveredClinic?.address.latitude === clinic.address.latitude ? 'hovered' : ''}`}
                                                    onMouseOver={() => setHoveredClinic(clinic)}
                                                    onMouseOut={() => setHoveredClinic(null)}
                                                    onClick={isMobile ? null : () => selectCompany(clinic?.company?.id)}
                                                >
                                                    <div className="searchedClinicPhoto">
                                                        <img src={clinic?.company?.logotype || clinicPhotoPlaceholder} alt={clinic?.company?.name || "Sem nome"} />
                                                    </div>
                                                    <div className="searchedClinicDetails flex-column justify-center align-items-start">
                                                        <div className="searchedClinicName">
                                                        {clinic?.company?.tradingName
                                                            ? (clinic?.company?.tradingName !== "Não definido"
                                                                ? clinic?.company?.tradingName
                                                                : (resumeCompanyName(clinic?.company?.name) || "Sem nome")
                                                            )
                                                            : "Sem nome"}
                                                        </div>
                                                        <div className="searchedClinicAddress">{clinic.address.fullAddress}</div>
                                                        <div className="searchedClinicDistance w100">
                                                            <div className="distanceText">{clinic.distanceKm}km de distância</div>
                                                            <div className="selectClinicButtonWrapper">
                                                                <Button loading={selectingCompany[clinic?.company?.id]} iconPos='right' icon="pi pi-chevron-right" className="selectClinicButton" size="small" text label="Selecionar" onClick={() => selectCompany(clinic?.company?.id)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                    </div>

                                </div>

                                {/* [OVER SCREEN] Scheduled Clinic / Optics */}
                                <div className={showScheduledClinic ? "flex-column justify-center align-items-center searchedSelectedClinic show" : "flex-column justify-center align-items-center searchedSelectedClinic hide"}>

                                    <div className="formContent w100 flex-column justify-center align-items-center">                                     

                                        {/* Selected Clinic/ Optics Info */}
                                        <div className="selectedClinic flex-column justify-center align-items-center">

                                            <div className={`clinicInfo ${isMobile ? "flex-column" : "flex-row"} justify-center align-items-start`}>

                                                {!isMobile && (
                                                <div className="clinicPhoto">
                                                    <img src={selectedCompany?.company?.logotype || clinicPhotoPlaceholder} alt="Imagem da clínica" />
                                                </div>
                                                )}

                                                <div className="clinicDetails flex-column justify-center align-items-start">
                                                    <div className="clinicName">
                                                    {selectedCompany?.company?.tradingName
                                                        ? (selectedCompany?.company?.tradingName !== "Não definido"
                                                            ? selectedCompany?.company?.tradingName
                                                            : (resumeCompanyName(selectedCompany?.company?.name) || "carregando...")
                                                        )
                                                        : "carregando..."}
                                                    </div>
                                                    <div className="clinicAddress">{selectedCompany?.address?.fullAddress || "carregando..."}</div>
                                                    <div className="clinicServicePrice">{searchType === "clinic" ? "Consulta por" : ""} {selectedCompany?.config?.servicePriceFor || (selectedCompany?.config?.name || "carregando...")}</div>
                                                     <div className="clinicDisclaimer">      
                                                        {searchType === "clinic"
                                                            ? notForMe
                                                            ? `Agende a consulta`
                                                            : `Agende sua consulta`
                                                            : notForMe
                                                            ? `Usufrua do desconto`
                                                            : `Usufrua do seu desconto`
                                                        }                                                
                                                      </div>     
                                                </div>

                                            </div>

                                            <div className="clinicSuccessScheduled">

                                                <p>
                                                {searchType === "clinic"
                                                    ? notForMe
                                                    ? `O agendamento foi registrado em nome de ${personName} e o valor da consulta está garantido!`
                                                    : `${personName}, sua solicitação de agendamento foi registrada e o valor da consulta está garantido!`
                                                    : notForMe
                                                    ? `O desconto foi registrado em nome de ${personName} e o cupom de desconto está garantido.`
                                                    : `${personName}, sua solicitação de desconto foi registrada e o cupom de desconto está garantido.`
                                                }
                                                </p>

                                                <p>
                                                {searchType === "clinic"
                                                    ? notForMe
                                                    ? `A clínica entrará em contato para finalizar o agendamento de ${personName}, ou você pode entrar em contato com a clínica.`
                                                    : `${personName}, a clínica entrará em contato com você pelo telefone informado para finalizar o seu agendamento, ou você pode entrar em contato com a clínica.`
                                                    : notForMe
                                                    ? `${personName} pode ir até a ótica para receber o desconto. Apresente um documento de identidade com os dados informados nessa solicitação.`
                                                    : `${personName}, agora você pode ir até a ótica para receber o desconto. Para isso, apresente um documento de identidade com os dados informados nessa solicitação.`
                                                }
                                                </p>

                                            </div>

                                        </div>   

                                    </div>

                                           {/*<div className="clinicSContactScheduled flex-column justify-center align-items-start"> 

                                                <p>Em caso de dúvidas, entre em contato com a {searchType == "" ? "clínica" : "ótica"} através dos números:</p>

                                                <div className="contactNumberItem w90 flex-row justify-center align-items-center">
                                                        <div className="flex-1 flex-row justify-start align-items-center" style={{gap:"1rem"}}>
                                                                <div className="phoneIcon"><img src={iconContactWpp} className="noSelect" /></div>
                                                                <div className="telNumber">(21) 1234-5678</div>
                                                        </div>
                                                        <div>
                                                            <div className="contactButtonWrapper">
                                                                <Button icon="pi pi-whatsapp" className="contactButton" size="small" text label="Iniciar conversa no whatsapp" onClick={() => handleStartChat(searchType)} />
                                                            </div>
                                                        </div>
                                                </div>

                                                <div className="contactNumberItem w90 flex-row justify-center align-items-center">
                                                        <div className="flex-1 flex-row justify-start align-items-center" style={{gap:"1rem"}}>
                                                                <div className="phoneIcon"><img src={iconContactPhone} className="noSelect" /></div>
                                                                <div className="telNumber">(21) 1234-5678</div>
                                                        </div>
                                                        <div>
                                                            <div className="contactButtonWrapper">
                                                                <Button icon="pi pi-phone" className="contactButton" size="small" text label="Fazer ligação por telefone" onClick={() => handleStartChat(searchType)} />
                                                            </div>
                                                        </div>
                                                </div>     

                                                <div className="w90 flex-column justify-center align-items-center" style={{marginTop:"3rem",gap:"0.5rem"}}>
                                                    <Button
                                                        label="Fechar janela"
                                                        rounded
                                                        className="headerButtonRight filled"
                                                        onClick={()=>close()}
                                                    /> 
                                                    <small style={{width:"70%",textAlign:"center"}}>Certifique-se de ter entrado em contato ou anotado os números acima antes de fechar a janela.</small>                                                   
                                                </div>                                           

                                            </div> */}  

                                            <div className="clinicSContactScheduled flex-column justify-center align-items-start"> 

                                                <p>Em caso de dúvidas, entre em contato com a {searchType === "" ? "clínica" : "ótica"} através dos números:</p>

                                                {selectedCompany.contacts?.phones?.length > 0 && selectedCompany.contacts.phones.map((phone, index) => (
                                                    <div key={`phone-${index}`} className={`${isMobile ? "flex-column" : "flex-row"} contactNumberItem w90 justify-center align-items-center`}>
                                                        <div className="flex-1 flex-row justify-start align-items-center" style={{ gap: "1rem" }}>
                                                            <div className="phoneIcon">
                                                                <img
                                                                    src={phone.phoneType === 'wpp' ? iconContactWpp : iconContactPhone}
                                                                    className="noSelect"
                                                                />
                                                            </div>
                                                            <div className="telNumber">
                                                                {maskPhone(phone.phoneNumber)}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className="contactButtonWrapper">
                                                                {phone.phoneType === 'wpp' ? (
                                                                    <Button
                                                                        icon="pi pi-whatsapp"
                                                                        className="contactButton"
                                                                        size="small"
                                                                        text
                                                                        label="Iniciar conversa no whatsapp"
                                                                        onClick={() => {handleStartContact(phone.phoneNumber,phone.phoneType);handleEventAppClick("whatsapp_contact")}}
                                                                    />
                                                                ) : (
                                                                    <Button
                                                                        icon="pi pi-phone"
                                                                        className="contactButton"
                                                                        size="small"
                                                                        text
                                                                        label="Fazer ligação por telefone"
                                                                        onClick={() => {handleStartContact(phone.phoneNumber,phone.phoneType);handleEventAppClick("phone_contact")}}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}

                                                {selectedCompany.contacts?.emails?.length > 0 && (
                                                    <div style={{ marginTop: "1rem", width: "100%" }}>
                                                        {!isMobile && (<p>E-mails de contato:</p>)}
                                                        {selectedCompany.contacts.emails.map((email, index) => (
                                                            <div key={`email-${index}`} className={`${isMobile ? "flex-column" : "flex-row"} contactNumberItem w90 flex-row justify-center align-items-center`}>
                                                                <div className="flex-1 flex-row justify-start align-items-center" style={{ gap: "1rem" }}>
                                                                    <div className="phoneIcon">
                                                                        <img src={iconContactEmail} className="noSelect" />
                                                                    </div>
                                                                    <div className="emailAddress">{email.email}</div>
                                                                </div>
                                                                <div>
                                                                    <div className="contactButtonWrapper">
                                                                        <Button
                                                                            icon="pi pi-envelope"
                                                                            className="contactButton"
                                                                            size="small"
                                                                            text
                                                                            label="Enviar e-mail"
                                                                            onClick={() => {window.open(`mailto:${email.email}`, '_blank');handleEventAppClick("email_contact")}}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                <div className="w90 flex-column justify-center align-items-center" style={{ marginTop: "2rem", gap: "0.5rem" }}>
                                                    <Button
                                                        label="Fechar janela"
                                                        rounded
                                                        className="headerButtonRight filled"
                                                        onClick={() => close()}
                                                    />
                                                    <small style={{ width: "70%", textAlign: "center" }}>
                                                        Certifique-se de ter entrado em contato ou anotado os números acima antes de fechar a janela.
                                                    </small>
                                                </div>

                                            </div>

                                </div>

                                {/* Selected Clinic/ Optics Info */}
                                <div className="selectedClinic flex-column justify-center align-items-center">

                                    <div className={`clinicInfo ${isMobile ? "flex-column" : "flex-row"} justify-center align-items-start`}>

                                        {!isMobile && (
                                        <div className="clinicPhoto">
                                            <img src={selectedCompany?.company?.logotype || clinicPhotoPlaceholder} alt="Imagem da clínica" />
                                        </div>
                                        )}

                                        <div className="clinicDetails flex-column justify-center align-items-start">
                                            <div className="clinicName">
                                            {selectedCompany?.company?.tradingName
                                                ? (selectedCompany?.company?.tradingName !== "Não definido"
                                                    ? selectedCompany?.company?.tradingName
                                                    : (resumeCompanyName(selectedCompany?.company?.name) || "carregando...")
                                                )
                                                : "carregando..."}
                                            </div>                                            
                                            <div className="clinicAddress">{selectedCompany?.address?.fullAddress || "carregando..."}</div>
                                            <div className="clinicServicePrice">{searchType === "clinic" ? "Consulta por" : ""} {selectedCompany?.config?.servicePriceFor || (selectedCompany?.config?.name || "carregando...")}</div>
                                            <div className="clinicDisclaimer">O valor do {searchType === "clinic" ? "serviço" : "desconto"} é o mesmo entre os parceiros.</div>     
                                        </div>

                                    </div>

                                </div>

                                {/* Customer Form */}
                                <div className="customerForm w100">

                                    <Grid container spacing={1}>

                                        <Grid item xs={12} sm={12}>
                                            <div className="w100 tAlignL formInfo">Preencha todos os dados abaixo para completar a solicitação:</div>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <div className="w100 tAlignL formControl">
                                            <InputText
                                                id="personDocument"
                                                autoComplete="new-password"
                                                disabled={loading}
                                                value={personDocument}
                                                onChange={(e) => setPersonDocument(maskCPF(e.target.value))}
                                                onBlur={(e) => {
                                                    const isValid = validarCPF(e.target.value);
                                                    if (!isValid) {
                                                        setTimeout(() => {
                                                            setAlertBody("CPF inválido. Por favor, verifique o número informado.");
                                                            setAlertTitle("CPF inválido");
                                                            setAlert(true);
                                                        },300);
                                                    }
                                                }}
                                                style={{ width: "100%" }}
                                                placeholder="Informe o seu CPF"        
                                            />
                                            </div>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <div className="w100 tAlignL formControl">
                                            <InputText
                                                id="personEmail"
                                                autoComplete="new-password"
                                                disabled={loading}
                                                value={personEmail}
                                                onChange={(e) => setPersonEmail(e.target.value)}
                                                onBlur={(e) => {
                                                    const isValid = validarEmail(e.target.value);
                                                    if (!isValid) {
                                                        setAlertBody("Email inválido. Por favor, verifique o email informado.");
                                                        setAlertTitle("Email inválido");
                                                        setAlert(true);
                                                    }
                                                }}                                                
                                                style={{ width: "100%" }}
                                                placeholder="Informe o seu Email"        
                                            />
                                            </div>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <div className="w100 tAlignL formControl">
                                            <InputText
                                                id="personPhone"
                                                autoComplete="new-password"
                                                disabled={loading}
                                                value={personPhone}
                                                onChange={(e) => setPersonPhone(maskPhone(e.target.value))}
                                                onBlur={(e) => {
                                                    const isValid = validarTelefone(e.target.value);
                                                    if (!isValid) {
                                                        // Pequeno delay para garantir que o React complete o render do campo
                                                        setTimeout(() => {
                                                            setAlertBody("Telefone inválido. Por favor, verifique o número informado.");
                                                            setAlertTitle("Telefone inválido");
                                                            setAlert(true);
                                                        }, 300);
                                                    }
                                                }}                                             
                                                style={{ width: "100%" }}
                                                placeholder="Informe o seu Telefone"        
                                            />
                                            </div>
                                        </Grid>                                                                                

                                    </Grid>
                                    
                                </div>

                                <div className="actions flex-row justify-center align-items-center" style={{gap:"1rem",marginTop:"1rem"}}>

                                    <div className="tAlignL formControl flex-row align-items-center" style={{ gap: '0.5rem' }}>
                                        <Checkbox
                                            inputId="acceptTerms"
                                            checked={acceptTerms}
                                            onChange={(e) => setAcceptTerms(e.checked)}
                                        />
                                        <label style={{ marginBottom: 0 }}>
                                            Concordo com a <span className="clickableLink" onClick={openPrivacyDialog} style={{textDecoration:"underline",cursor:"pointer"}}>Política de Privacidade</span> e com os <span className="clickableLink" onClick={openUsageDialog} style={{textDecoration:"underline",cursor:"pointer"}}>Termos de Uso</span>
                                        </label>
                                    </div>                                    
                                    
                                </div>                                

                                <div className="w100 actions flex-column justify-center align-items-center" style={{gap:"1rem",marginTop:"0rem"}}>

                                    {/*<div className="clinicDisclaimer tAlignL">Caso queira outra opção de clínica selecione "Ver outras clínicas" abaixo.</div>*/}
                                    
                                    <div className="w100 tAlignL formControl flex-column align-items-center" style={{ gap: '0.5rem' }}>
                                      
                                                <Button
                                                    label={loadingCompany ? "Iniciando conversa" : (searchType == 'clinic' ? "Iniciar conversa com a clínica" : "Iniciar conversa com a ótica")}
                                                    icon="pi pi-whatsapp"
                                                    rounded
                                                    /*disabled={!formValidated}*/
                                                    className="w100 startChatButton filled"
                                                    loading={loadingCompany}
                                                    onClick={()=>{handleStartChat(searchType);handleEventAppClick("whatsapp_chat")}}
                                                />

                                                <div className="flex-row justify-start align-items-center" style={{ gap: '0.5rem', marginTop: '0.5rem' }}>
                                                    <InputSwitch id="switch" className="notForMeSelector" checked={notForMe} onChange={(e) => setNotForMe(e.value)} />
                                                    <div className="notForMeLabel" htmlFor="switch">
                                                        {searchType == 'clinic' ? "Marque se essa consulta não for para você" : "Marque se o desconto não for para você"}
                                                        
                                                        <Tooltip position="bottom" tooltipOptions={{ position: 'top' }} target=".notForMeSelector" content={searchType == 'clinic' ? "Essa opção é para quando você está agendando uma consulta para outra pessoa." : "Essa opção é para quando você está gerando desconto para outra pessoa."} />
                                                    </div>
                                                </div>
                                                    
                                    </div>                                    
                                    
                                </div>                                

                            </div>

                           {(!showScheduledClinic && !showNotFoundClinic && foundCompanies.length > 1) &&
                           <>
                            <Button
                                label={searching ? "Buscando..." : searchType == "clinic" ? "Ver outras clínicas" : "Ver outras óticas"}
                                rounded
                                text
                                disabled={searching || showSearchedClinics}
                                className="w100 startSearchButton"
                                loading={searching}
                                onClick={()=>handleStartSearch(searchType)}
                            />
                            </>
                           }
                            
                        </div>
                    </div>
                    </>
                    }

                    {/*(center && !loading && showScheduledClinic) &&*/}
                    {( (center && !loading && !isMobile) || (center && !loading && isMobile && !showScheduledClinic)) &&
                    <div style={{ flex:1,height: 'inherit', width: 'inherit', marginTop:isMobile ? "1rem" : "",minHeight:isMobile ? "12rem" : "" }}>
                    <APIProvider apiKey={apiKey}>
                        <Map
                        defaultZoom={zoom || 11}
                        defaultCenter={center}
                        gestureHandling={'greedy'}
                        onZoomChanged={(e) => setZoom(e.zoom)}
                        disableDefaultUI={false}
                        fullscreenControlOptions={false}
                        mapTypeControl={false}
                        streetViewControl={false}
                        fullscreenControl={false}
                        className="mapContainer"
                        options={mapOptions}
                        > 
                        {/*<Marker position={{lat: parseFloat(markerCenter.lat), lng:parseFloat(markerCenter.lng)}} />*/}

                        {showSearchedClinics && (
                            <>
                            {foundMapCompanies.map((clinic, index) => (
                                <Marker
                                    key={index}
                                    position={{
                                        lat: parseFloat(clinic.address.latitude),
                                        lng: parseFloat(clinic.address.longitude)
                                    }}
                                    onMouseOver={() => {
                                        setHoveredClinic(clinic);

                                        // Encontra o índice e rola até o elemento
                                        const itemIndex = foundMapCompanies.findIndex(c => c.address.latitude === clinic.address.latitude && c.address.longitude === clinic.address.longitude);
                                        const itemEl = itemRefs.current[itemIndex];
                                        if (itemEl) {
                                            itemEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                        }
                                    }}
                                    onMouseOut={() => setHoveredClinic(null)}
                                />
                            ))}
                            </>
                          )
                        }

                        {/* User Address Marker */}
                        <Marker
                            key={'user-address'}
                            position={{
                                lat: parseFloat(coordinates.lat),
                                lng: parseFloat(coordinates.lng)
                            }}
                            icon={{
                                url: iconHomeAddress,
                                scaledSize: window.google ? new window.google.maps.Size(45, 45) : undefined // tamanho mais elegante
                            }}
                            onMouseOver={() => {
                                setHoveredClinic({
                                    company: { name: 'Seu Endereço aproximado' },
                                    address: {
                                        fullAddress: address.fullAddress,
                                        latitude: coordinates.lat,
                                        longitude: coordinates.lng
                                    },
                                    distanceKm: ''
                                });
                            }}
                            onMouseOut={() => setHoveredClinic(null)}
                        />

                        {!showSearchedClinics &&
                            <>
                            <Marker
                                key={1}
                                position={{
                                    lat: parseFloat(selectedCompany.address.latitude),
                                    lng: parseFloat(selectedCompany.address.longitude)
                                }}
                                onMouseOver={() => {
                                    setHoveredClinic(selectedCompany);

                                    // Encontra o índice e rola até o elemento
                                    const itemIndex = selectedCompany.findIndex(c => c.address.latitude === selectedCompany.address.latitude && c.address.longitude === selectedCompany.address.longitude);
                                    const itemEl = itemRefs.current[itemIndex];
                                    if (itemEl) {
                                        itemEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    }
                                }}
                                onMouseOut={() => setHoveredClinic(null)}
                            />
                            </>
                        }                        

                        {hoveredClinic && 
                        (
                            <InfoWindow
                                position={{
                                    lat: parseFloat(hoveredClinic.address.latitude),
                                    lng: parseFloat(hoveredClinic.address.longitude)
                                }}
                                options={window.google ? { pixelOffset: new window.google.maps.Size(0, -40) } : {}}
                                onCloseClick={() => setHoveredClinic(null)}
                            >
                                <div style={{ maxWidth: '200px' }}>
                                    <strong>{hoveredClinic?.company?.name || "Sem nome"}</strong><br />
                                    {hoveredClinic.address.fullAddress}<br />
                                    {hoveredClinic.distanceKm ? hoveredClinic.distanceKm+"km de distância" : ""}
                                </div>
                            </InfoWindow>
                        )}
                         

                        </Map>
                    </APIProvider>
                    </div>
                    }                    

			    </div>

                {/* Modal: Política de Privacidade */}
                <Dialog
                    header="Política de Privacidade"
                    visible={showPrivacyDialog}
                    style={{ width:isMobile ? '90vw' : '70vw', maxWidth: '800px', height:isMobile ? '90vh' : '80vh'}}
                    onHide={() => {setShowPrivacyDialog(false); enableBodyScroll();}}
                    closeOnEscape={()=>enableBodyScroll()}
                    dismissableMask={true} 
                    modal
                >
                    {loadingPrivacy ? (
                    <div style={{ padding: '2rem' }}>
                        <Skeleton width="60%" height="2rem" style={{ marginBottom: '1rem' }} /><br />
                        <Skeleton width="100%" height="1rem" style={{ marginBottom: '0.5rem' }} /><br />
                        <Skeleton width="95%" height="1rem" style={{ marginBottom: '0.5rem' }} /><br />
                        <Skeleton width="90%" height="1rem" style={{ marginBottom: '0.5rem' }} /><br />
                        <Skeleton width="85%" height="1rem" />
                    </div>
                    ) : (
                    <div
                        dangerouslySetInnerHTML={{ __html: privacyContent }}
                    />
                    )}
                </Dialog>


                {/* Modal: Termos de Uso */}
                <Dialog
                    header="Termos de Uso"
                    visible={showUsageDialog}
                    style={{ width:isMobile ? '90vw' : '70vw', maxWidth: '800px', height:isMobile ? '90vh' : '80vh'}}
                    onHide={() => {setShowUsageDialog(false); enableBodyScroll();}}
                    closeOnEscape={()=>enableBodyScroll()}   
                    dismissableMask={true}      
                    modal
                >
                    {loadingUsage ? (
                    <div style={{ padding: '2rem' }}>
                        <Skeleton width="60%" height="2rem" style={{ marginBottom: '1rem' }} /><br />
                        <Skeleton width="100%" height="1rem" style={{ marginBottom: '0.5rem' }} /><br />
                        <Skeleton width="95%" height="1rem" style={{ marginBottom: '0.5rem' }} /><br />
                        <Skeleton width="90%" height="1rem" style={{ marginBottom: '0.5rem' }} /><br />
                        <Skeleton width="85%" height="1rem" />
                    </div>
                    ) : (
                    <div
                        dangerouslySetInnerHTML={{ __html: usageContent }}
                    />
                    )}
                </Dialog>

            </Dialog>	

            <AlertView
                alert={alert}
                setAlert={setAlert}
                alertTitle={alertTitle}
                alertBody={alertBody}	
                setAlertAction={setAlertAction}
                scrollBlock={false}			
            />

	</>	
	);
	
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(MapSearchClinicView);	
